<template>
  <span>
    <v-row :style="`background-color: ${background_color}`" v-if="index == 0">
      <v-col
        :cols="size == 'horz' ? 1 : 2"
        class="ml-7"
        :h3Class="h3Class"
        :style="`color: ${font_color}`"
      >
        DST
      </v-col>
      <v-col class="text-h4" style="color: #757575"></v-col>
      <v-col
        cols="3"
        class="mr-8 text-right"
        :h3Class="h3Class"
        :style="`color: ${font_color}`"
      >
        Departs
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row
      :class="className"
      :style="`background-color: ${background_color}; color: ${font_color}`"
    >
      <!-- <v-col :cols="size == 'horz' ? 1 : 2" :class="h2Class">
        {{ service.route_short_name }}
      </v-col> -->
      <v-col class="font-weight-bold" :class="h1Class">
        <small v-if="showTripShortName">{{ service.trip_short_name }} | </small>
        {{ service.trip_headsign }}
        <small class="red--text" v-if="departure_delay">{{
          departure_delay
        }}</small></v-col
      >
      <v-col cols="4" class="text-right" :class="h2Class">
        <DepartTime :time="service.adjusted_departure_time"></DepartTime>
        <DepartIn
          :departure_time="service.adjusted_departure_time"
          :timeZone="timeZone"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import DepartIn from "./DepartIn.vue";
import DepartTime from "./DepartTime.vue";
export default {
  inject: ["h1Class", "h2Class", "size", "h3Class"],
  props: {
    background_color: String,
    font_color: String,
    timeZone: String,
    index: Number,
    service: {
      type: Object,
      required: true,
    },
  },
  components: { DepartTime, DepartIn },
  computed: {
    // Luas trip_short_name is an internal block code (e.g. "290.MF-BH.93-GRN-y11"),
    // not a service number, so it is hidden for that agency.
    showTripShortName() {
      if (!this.service.trip_short_name) return false;
      return !/luas/i.test(this.service.agency_name || "");
    },
    departure_delay() {
      if (!this.service.departure_delay) return "";
      const delay = parseInt(this.service.departure_delay / 60);
      if (delay <= 0) return "";
      return `+${delay}`;
    },
    className() {
      const { name } = this.$vuetify.breakpoint;
      let className = " ma-5";
      switch (name) {
        case "xs":
          className = " ma-3";
          break;
        case "sm":
        case "md":
        case "lg":
        case "xl":
      }
      return className;
    },
  },
};
</script>

<style scoped></style>
